import {
  InsuranceAdvice,
  InsuranceCoverage,
  PurchaseRecommendation,
  UserAuthorizationLevel,
} from "Store/advice/interfaces";
import { getAdviceRestrictions, getCorrectPaymentValue } from "../utils";

import { VALUE_TYPE } from "Components/NumberValue";
import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { formatToLocaleString } from "Formatting/formatNumber";
import { isDefined } from "Utils/functions";
import React from "react";
import { AdviceTextsResult } from "./getAdviceTexts";

export const generateAdviceTextsCriticalIllness = (
  isAdvisor: boolean,
  insuranceAdvice: InsuranceAdvice,
  adviceTexts: any,
  lang: string,
): AdviceTextsResult => {
  const { singlePayment, recommendedCoverage } = insuranceAdvice;
  const adviceValue = getCorrectPaymentValue(
    UserAuthorizationLevel.PRODUCT_MANAGER,
    singlePayment,
  );
  const advisorReachedMaxPayout =
    isAdvisor &&
    adviceValue === getAdviceRestrictions(insuranceAdvice).maxProductManager;
  const shouldPurchaseFromAdvisor =
    !isAdvisor &&
    singlePayment.recommendationConfiguration.recommendation ===
      PurchaseRecommendation.PURCHASE_FROM_ADVISOR;

  const insuranceDesc = (): React.ReactElement => {
    const { desc } = adviceTexts;

    if (advisorReachedMaxPayout) {
      return (
        <Description fw={400} size="14px">
          {`${desc.part1.weAdvice[lang]}${formatToLocaleString(adviceValue)} ${
            VALUE_TYPE.NOK
          }. ${desc.part1.maximumAmount[lang]}`}
        </Description>
      );
    }

    const weAdvice = shouldPurchaseFromAdvisor
      ? desc.part1[lang]
      : `${desc.part1.weAdvice[lang]}${formatToLocaleString(adviceValue)} ${
          VALUE_TYPE.NOK
        } `;

    let whichCoversIncome = "";
    if (recommendedCoverage === InsuranceCoverage.TOP) {
      whichCoversIncome = desc.part2.top[lang];
    } else if (recommendedCoverage === InsuranceCoverage.PLUS) {
      whichCoversIncome = desc.part2.plus[lang];
    } else if (recommendedCoverage === InsuranceCoverage.BASIC) {
      whichCoversIncome = desc.part2.basic[lang];
    }

    const becauseOf = desc.part3[lang];

    let yourEconomicalSituation = "";
    if (recommendedCoverage === InsuranceCoverage.BASIC) {
      yourEconomicalSituation = desc.part4.basic[lang];
    } else if (recommendedCoverage === InsuranceCoverage.PLUS) {
      yourEconomicalSituation = desc.part4.plus[lang];
    } else if (recommendedCoverage === InsuranceCoverage.TOP) {
      yourEconomicalSituation = desc.part4.top[lang];
    }
    return (
      <Description fw={400} size="14px">
        {`${weAdvice}${whichCoversIncome}${becauseOf}${yourEconomicalSituation}`}
      </Description>
    );
  };

  return {
    header: adviceTexts.header[lang],
    title: adviceTexts.title[lang],
    desc: isDefined(recommendedCoverage) ? insuranceDesc() : <></>,
  };
};
